export default __webpack_public_path__ + "static/media/Amex.07e5879d.svg";